import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import ProtectedRoute from "./components/ProtectedRoute";
import LoginPage from "./pages/LoginPage";
import AdminPage from "./pages/AdminPage";
import UsersPage from "./pages/UsersPage";
import ConfigPage from "./pages/ConfigPage";
import AlmacenPage from "./pages/AlmacenPage";
import EquiposPage from "./pages/EquiposPage";
import DashboardPage from "./pages/DashboardPage";
import AdminDashboardPage from "./pages/AdminDashboardPage";
import AdminNotificationsPage from "./pages/AdminNotificationsPage";
import EmpresaDetallePage from "./pages/EmpresaDetallePage";
import EquipoProfilePage from "./pages/EquipoProfilePage/EquipoProfilePage.jsx";
import DetalleOCPage from "./pages/DetalleOCPage.jsx";
import ProfilePage from "./pages/user/ProfilePage.jsx";
import ServiciosPage from "./pages/ServiciosPage.jsx";
import MisServiciosPage from "./pages/MisServiciosPage.jsx";
import GestionServicioPage from "./pages/GestionServicioPage.jsx";
import ReportesPage from "./pages/ReportesPage.jsx";
import LandingPage from "./pages/LandingPage";
import VerificarReportePage from "./pages/VerificarReportePage";
import CertificadoPublicoPage from "./pages/CertificadoPublicoPage";
import RegisterPage from "./pages/RegisterPage";
import VerifyEmailPage from "./pages/VerifyEmailPage";
import UnsubscribeVencidosPage from "./pages/UnsubscribeVencidosPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import InstalacionPWA from "./components/InstalacionPWA";
import OpenEquipo from "./pages/OpenEquipo";
import ServicioActivoFloating from "./components/ui/ServicioActivoFloating";
import EmailVerificationBanner from "./components/EmailVerificationBanner";
import CookieConsentBanner from "./components/CookieConsentBanner";
import LegalFooterBar from "./components/LegalFooterBar";
import PolicyConsentModal from "./components/PolicyConsentModal";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import DataTreatmentPage from "./pages/DataTreatmentPage";
import QRScannerPage from "./pages/QRScannerPage";
import WarehouseStockPage from "./pages/storage/WarehouseStockPage";
import PredictivoPage from "./pages/PredictivoPage";
import EnvironmentalMonitoringPage from "./pages/environment/EnvironmentalMonitoringPage";
import { useSyncUser } from "./hooks/useSyncUser";
import SoportesPage from "./pages/SoportesPage";
import SoporteMetricasPage from "./pages/SoporteMetricasPage";
import CostosClientePage from "./pages/CostosClientePage";
import TCOPage from "./pages/TCOPage";
import ConfigCostosPage from "./pages/config/ConfigCostosPage";
import MobiliarioPage from "./pages/MobiliarioPage";
import MobiliarioProfilePage from "./pages/MobiliarioProfilePage";

function App() {
  useSyncUser();
  return (
    <BrowserRouter>
      <InstalacionPWA />
      <ServicioActivoFloating />
      <EmailVerificationBanner />
      <PolicyConsentModal />
      <CookieConsentBanner />
      <LegalFooterBar />
      <Routes>
        <Route path="/landing" element={<LandingPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/politica-privacidad" element={<PrivacyPolicyPage />} />
        <Route path="/tratamiento-datos" element={<DataTreatmentPage />} />
        <Route path="/verify-email" element={<VerifyEmailPage />} />
        <Route path="/notificaciones/desuscrito" element={<UnsubscribeVencidosPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/open/equipo/:id" element={<OpenEquipo />} />
        <Route
          path="/open/mobiliario/:id"
          element={<MobiliarioProfilePage publicView />}
        />
        <Route
          path="/scan"
          element={<ProtectedRoute element={<QRScannerPage />} />}
        />
        <Route
          path="/verify/:tokenPublico"
          element={<VerificarReportePage />}
        />
        <Route path="/certificado/:token" element={<CertificadoPublicoPage />} />
        <Route path="/" element={<Navigate to="/dashboard" />} />
        <Route path="/login" element={<LoginPage />} />

        {/* Rutas protegidas */}
        <Route
          path="Company"
          element={<ProtectedRoute element={<AdminPage />} />}
        />
        <Route
          path="/users"
          element={<ProtectedRoute element={<UsersPage />} />}
        />
        <Route
          path="/config"
          element={<ProtectedRoute element={<ConfigPage />} />}
        />
        <Route
          path="/storage"
          element={<ProtectedRoute element={<AlmacenPage />} />}
        />
        <Route
          path="/equipos"
          element={<ProtectedRoute element={<EquiposPage />} />}
        />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute
              element={<DashboardPage />}
              permission="dashboard.ver"
            />
          }
        />
        <Route
          path="/equipos/:id"
          element={<ProtectedRoute element={<EquipoProfilePage />} />}
        />
        <Route
          path="/detalleOC/:id"
          element={<ProtectedRoute element={<DetalleOCPage />} />}
        />
        <Route
          path="/profile"
          element={<ProtectedRoute element={<ProfilePage />} />}
        />
        <Route
          path="/services"
          element={<ProtectedRoute element={<ServiciosPage />} />}
        />
        <Route
          path="/my_services"
          element={
            <ProtectedRoute
              element={<MisServiciosPage />}
              permission="servicios.gestionar"
            />
          }
        />
        <Route
          path="/manage/:id"
          element={
            <ProtectedRoute
              element={<GestionServicioPage />}
              permission="servicios.gestionar"
            />
          }
        />
        <Route
          path="/reports"
          element={<ProtectedRoute element={<ReportesPage />} />}
        />
        <Route
          path="/predictivo"
          element={<ProtectedRoute element={<PredictivoPage />} />}
        />
        <Route
          path="/environmental"
          element={<ProtectedRoute element={<EnvironmentalMonitoringPage />} />}
        />
        <Route
          path="/adminDashboard"
          element={
            <ProtectedRoute
              element={<AdminDashboardPage />}
              onlyEmail="jarenas@previonix.com"
            />
          }
        />
        <Route
          path="/adminDashboard/notificaciones"
          element={
            <ProtectedRoute
              element={<AdminNotificationsPage />}
              onlyEmail="jarenas@previonix.com"
            />
          }
        />
        <Route
          path="/adminDashboard/empresa/:id"
          element={
            <ProtectedRoute
              element={<EmpresaDetallePage />}
              onlyEmail="jarenas@previonix.com"
            />
          }
        />

        <Route
          path="/almacen/:almacenId/stock"
          element={<ProtectedRoute element={<WarehouseStockPage />} />}
        />

        {/* Módulo Mobiliario */}
        <Route
          path="/mobiliario"
          element={
            <ProtectedRoute
              element={<MobiliarioPage />}
              permission="mobiliario.ver"
            />
          }
        />
        <Route
          path="/mobiliario/:id"
          element={
            <ProtectedRoute
              element={<MobiliarioProfilePage />}
              permission="mobiliario.ver"
            />
          }
        />

        {/* Módulo Soporte */}
        <Route
          path="/soporte"
          element={
            <ProtectedRoute
              element={<SoportesPage />}
              permission="soporte.ver"
            />
          }
        />
        <Route
          path="/soporte/metricas"
          element={
            <ProtectedRoute
              element={<SoporteMetricasPage />}
              permission="soporte.reportes"
            />
          }
        />

        {/* Módulo Costos por Cliente */}
        <Route
          path="/costos-cliente"
          element={
            <ProtectedRoute
              element={<CostosClientePage />}
              permission="costos_cliente.ver"
            />
          }
        />

        {/* Módulo TCO */}
        <Route
          path="/tco"
          element={
            <ProtectedRoute element={<TCOPage />} permission="tco.ver" />
          }
        />

        {/* Configuración de Costos */}
        <Route
          path="/config/costos"
          element={
            <ProtectedRoute
              element={<ConfigCostosPage />}
              permission="costos_config.ver"
            />
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
